import { RouteObject } from "react-router-dom";

export const tagsRoutes: RouteObject[] = [{ index: true, lazy: () => import("./TagsManagementScreen") }];
